import axios from "axios";
// using Axios for fetching data from https://unsplash.com/developer photo api

export default axios.create({
    baseURL: 'https://shazam.p.rapidapi.com',
    headers: {
        'x-rapidapi-host': 'shazam.p.rapidapi.com',
        'x-rapidapi-key': 'e0db8f524amsh35e05bc1de5c2bap134b88jsnfe123d667f47'
    },
    params: {key: '484129036', locale: 'en-US'}    
})